import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { toast } from "sonner";

import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { UserAuthLayout } from "../../components/user/UserAuthLayout";
import { GoogleLoginButton } from "../../components/user/GoogleLoginButton";
import { useUserAuth, formatApiErrorDetail } from "../../context/UserAuthContext";

export default function UserLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useUserAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const redirect = location.state?.from || "/conta";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await login(email, password);
      if (data.linked_tickets > 0) {
        toast.success(`Sessão iniciada · ${data.linked_tickets} bilhete(s) associado(s) à sua conta.`);
      } else {
        toast.success("Sessão iniciada com sucesso");
      }
      navigate(redirect);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao entrar");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <UserAuthLayout
      title="Entrar"
      subtitle="Aceda à sua conta para ver os seus bilhetes."
      footer={
        <>
          Ainda não tem conta?{" "}
          <Link to="/registar" className="text-amber-400 hover:text-amber-300" data-testid="link-register">
            Criar conta
          </Link>
        </>
      }
    >
      <GoogleLoginButton />
      <div className="relative my-5">
        <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-white/10" /></div>
        <div className="relative flex justify-center text-xs uppercase tracking-wider"><span className="bg-zinc-950 px-2 text-zinc-500">ou</span></div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4" data-testid="login-form">
        <div>
          <Label htmlFor="email" className="text-zinc-300">Email</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="seu@email.com"
            required
            autoComplete="email"
            autoFocus
            className="input-dark mt-1.5"
            data-testid="login-email"
          />
        </div>
        <div>
          <div className="flex items-center justify-between">
            <Label htmlFor="password" className="text-zinc-300">Password</Label>
            <Link to="/esqueci-password" className="text-xs text-amber-400 hover:text-amber-300" data-testid="link-forgot">
              Esqueci-me
            </Link>
          </div>
          <Input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            required
            autoComplete="current-password"
            className="input-dark mt-1.5"
            data-testid="login-password"
          />
        </div>
        <Button
          type="submit"
          disabled={submitting || !email || !password}
          className="btn-primary w-full"
          data-testid="login-submit"
        >
          {submitting ? "A entrar..." : "Entrar"}
        </Button>
      </form>
    </UserAuthLayout>
  );
}
